<template>
  <v-overlay :value="overlay" z-index="1000">
    <v-container>
      <center class="mb-5">
        <v-progress-circular indeterminate size="40"></v-progress-circular>
      </center>
      <div class="font-weight-bold">{{message}}</div>
    </v-container>
  </v-overlay>
</template>
<script>
export default {
  name: 'sec-loading',
  components: {
  },
  data () {
    return {
      overlay: false,
      message: ''
    }
  },
  created () {
  },
  mounted () {
  },
  /* 
    <사용법>

    1. <s-loading ref="loading"></s-loading> 추가
    2. 함수에서 필요한 시점에 아래 설명대로 사용한다.
     로딩 시작
     - this.$refs.loading.start('message')
     로딩 종료
     - this.$refs.loading.end()
  */
  methods: {
    start (message) {
      this.message = message
      this.overlay = true
    },
    end () {
      this.overlay = false
    }
  }
}
</script>
<style scoped>

</style>
